export const itemTypes = [
  '个人飞行赛',
  '第三视角无人机竞速赛',
  '空中格斗赛',
  '无人机足球赛',
  '雷霆行动赛',
  '第一视角竞速赛',
  '行业应用赛',
];
export const itemGroups = [
  '小学组',
  '初中组',
  '高中组-含中专与职高',
  '中学组',
  '公开组',
];
